import React, { createContext, useContext, useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// Hôtes historiques DNF : conservent leur habillage même si l'API ne renvoie
// pas (encore) de tenant (fenêtre de déploiement, erreur réseau).
const LEGACY_DNF_HOSTS = ['dnfsas.fr', 'www.dnfsas.fr'];

const TenantContext = createContext({ tenant: null, tenantLoading: true, isLegacyDnfHost: false });

// Tenant du domaine courant (résolution Host → tenant côté API).
// null sur le domaine produit.
export function TenantProvider({ children }) {
  const [tenant, setTenant] = useState(null);
  const [tenantLoading, setTenantLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/public/tenant`)
      .then(r => (r.ok ? r.json() : { tenant: null }))
      .then(data => setTenant(data.tenant || null))
      .catch(() => setTenant(null))
      .finally(() => setTenantLoading(false));
  }, []);

  const isLegacyDnfHost = LEGACY_DNF_HOSTS.includes(window.location.hostname);

  // Titre de l'onglet : nom du tenant sur son domaine, marque produit sinon.
  // Les hôtes DNF historiques gardent leur titre d'origine (index.html).
  useEffect(() => {
    if (tenantLoading || isLegacyDnfHost) return;
    if (tenant?.name) {
      document.title = `${tenant.name} — Suivi de chantier`;
    } else {
      document.title = 'Jalonne — Suivi de chantier';
    }
  }, [tenant, tenantLoading, isLegacyDnfHost]);

  return (
    <TenantContext.Provider value={{ tenant, tenantLoading, isLegacyDnfHost }}>
      {children}
    </TenantContext.Provider>
  );
}

export const useTenant = () => useContext(TenantContext);
